import React from 'react'
import farmer3 from './Images/farmers-3.jpg';

import reform from './Images/reform-1.jpg'
import Pres from './Images/pres.jpg';
import farmer5 from './Images/farmers-5.jpg'
const MoreAboutUs = () => {

  return (
    <div>
      <div className='container px-5 py-2 mx-auto flex flex-col'>
        {/* Banner Container */}
        <div children="lg:w-4/6 mx-auto">


          <div>
            <section class="">
              <div className='block md:flex w-full mt-12 mb-2 py-12'>
                <div className='flex flex-col items-center justify-center '>
                  <h1 className=' text-green-600 pl-3 font-semibold text text-2xl text-center md:text-left md:text-5xl lg:text-7xl'>OUR PURPOSE</h1>


                </div>
                {/* Right Side Image */}
                <div className='flex-2 bg-cover bg-no-repeat bg-center'>
                  <img src={reform} className='' alt='image' ></img>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 ">

                <ol class="mb-4 mt-4 text-lg leading-relaxed list-disc flex-inline">
                  {/* Make title text left-justify */}
                  <h1 className='mb-4 mt-4  text-3xl font-medium text-left'>ASSISTANCE TO FARMERS</h1>
                  <li className='m-2 p-2 text-md text-left'> Lend at low interest.</li>
                  <li className='m-2 p-2 text-md text-left'>	Buy equipment at low prices</li>
                  <li className='m-2 p-2 text-md text-left'>	Innovative knowledge about farming</li>
                </ol>

                <ol class="mb-4 mt-4 text-lg leading-relaxed list-disc">
                  <h1 className='mb-4 mt-4  text-3xl font-medium text-left'> RISE OUT OF POVERTY</h1>
                  <li className='m-2 p-2 text-md text-left'>	Increase the income of farmers</li>
                  <li className='m-2 p-2 text-md text-left'>	Give more opportunities</li>
                  <li className='m-2 p-2 text-md text-left'>	Develop the economy</li>
                </ol>


              </div>
            </section>

          </div>
          <section class="mt-4">
            <h1 class="text-center font-medium text-4xl md:text-2xl lg:text-6xl py-12 text-green-600"> HISTORY OF E-AGRO
            </h1>
            <div class="container mx-auto flex px-5 md:flex-row flex-col items-center">

              <div class="flex flex-col text-right md:text-center">
                <div className='py-6 mb-6'>
                  <h1 class="text-center md:leading-relaxed sm:text-4xl text-3xl mb-4 font-medium text-gray-900 ">OUR INSPIRATION</h1>
                  <p class="mb-4 text-center md:leading-relaxed text-lg">The agricultural sector has been long neglected in the country. Many believe that there is no money in agriculture, but we beg to differ.</p>
                  <p class="mb-4 text-center md:leading-relaxed text-lg">Farming can be financially rewarding. Bayambang, Pangasinan is a municipality that relies on agriculture as its source of livelihood and economic development.</p>
                  <p class="mb-4 text-center md:leading-relaxed text-lg">Even so, the biggest challenge it faces is poverty among farmers</p>
                </div>

                <p className='sm:text-4xl text-3xl mb-4 font-medium text-center text-gray-900'> Common problems of farmers  </p>

                <div className='col-span-1 grid grid-cols-1 md:grid-cols-5 items-stretch md:flex-row  gap-2'>
                  {/* Cards */}
                  <div className='bg-white rounded-xl shadow-2xl mt-2 p-2'>
                    <div class="flex p-8 flex-col">
                      <p className='m-2 p-2 font-bold text-md text-center'>		High input costs but low yield.</p>

                    </div>
                  </div>

                  <div className='bg-white rounded-xl shadow-2xl mt-2 p-2'>
                    <div class="flex p-8 flex-col">
                      <p className='m-2 p-2 font-bold text-md text-center'>	Difficult access to low cost of funds</p>


                    </div>
                  </div>

                  <div className='bg-white rounded-xl shadow-2xl mt-2 p-2'>
                    <div class="flex p-8 flex-col">
                      <p className='m-2 p-2 font-bold text-md text-center'>	Dependence on high interest loans</p>

                    </div>
                  </div>

                  <div className='bg-white rounded-xl shadow-2xl mt-2 p-2'>
                    <div class="flex p-8 flex-col">
                      <p className='m-2 p-2 font-bold text-md text-center'>	Lack of market access</p>

                    </div>
                  </div>

                  <div className='bg-white rounded-xl shadow-2xl mt-2 p-2'>
                    <div class="flex p-8 flex-col">
                      <p className='m-2 p-2 font-bold text-md text-center'>		Lack of access to credit without collateral needed</p>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>

          <div className='py-12'>
            <h1 class="text-center font-medium text-xl  text-green-600 mt-8">
              <strong className='text-3xl'>PHP 3,100 </strong>- A Filipino farmer's average monthly income.
            </h1>

            <h1 class="text-center font-medium text-xl text-green-600 mt-8">
              <strong className='text-3xl'>30,850 FILIPINOS  </strong>are Members of Bayambang's poor farming families.
            </h1>

            <h1 class="text-center font-medium text-xl  text-green-600 mt-8">
              <strong className='text-3xl'>66 BARANGAYS  </strong>rely on farming as their livelihood
            </h1>
          </div>

          <div className='py-6 '>
            <p class="mb-8 leading-relaxed text-xl">As mayor of Bayambang, an agricultural municipality, Mayor Cezar T. Quiambao decided to build programs to promote the welfare of local farmers.</p>
            <p class="mb-8 leading-relaxed text-xl">So by August 28, 2018, National Heroes’ Day, he started the program “Rebolusyon Laban sa Kahirapan” in the whole municipality of Bayamabang to face challenges head-on and provide solutions.</p>
            <p class="mb-8 leading-relaxed text-xl">His desire to create betterment for farmers led to the “Bayambang Poverty Reduction Plan (BPRP) 2018-2028”. </p>
            <p class="mb-8 leading-relaxed text-xl">One of its five sectors focuses on “Agricultural Modernization." It is a program that helps farmers achieve a comfortable life with the best resources and services provided.   </p>
          </div>

          <section class="">
            <div class="container mx-auto flex px-5 py-12 md:flex-row flex-col items-center">
              <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
                <img src={Pres} class="object-cover object-center rounded" alt="hero"></img>
              </div>
              <div class="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-end md:text-right items-center text-center">
                <h1 class="text-center md:text-right font-medium text-3xl  mb-4 md:text-4xl lg:text-6xl text-green-600">2021 GLOBAL MAYORS CHALLENGE</h1>
                <p class="mb-8 leading-relaxed text-xl">Mayor Cezar T. Quiambao joined the Bloomberg Philanthropies’ 2021 Global Mayor Challenge, which encourages city leaders to develop their most revolutionary ideas in response to Covid 19.</p>
                <p class="mb-8 leading-relaxed text-xl">As his official entry, he established the Farmers Assistance Portal- one-stop-shop of support services for farmers to prioritize their needs. It had shown financial growth in both farmers and persons in the agricultural industry.</p>
                <p class="mb-8 leading-relaxed text-xl">His entry was not selected. Even so, Mayor Quiambao chose to expand it further to promote the welfare of farmers and others within the agricultural sector.</p>

              </div>
            </div>
          </section>

          <div className='block md:flex w-full mt-20 mb-20 py-12'>
            <div className='flex flex-col justify-center '>
              <h1 className=' title-font sm:text-5xl text-4xl mb-4 font-medium text-green-600 text-center md:text-left'>HOW WE CAME TO BE</h1>

              <p class="mb-8 leading-relaxed text-xl">Mayor Cezar T. Quiambao collaborated with businessmen from the private sector to bring up E-Agro Corporation to turn these agricultural programs into reality with funding and resources to make it sustainable.</p>
              <p class="mb-8 leading-relaxed text-xl"><strong>E-Agro Corporation </strong>now serves as a bridge for farmers and suppliers alike towards
                support, growth, and stability.
              </p>

            </div>
            {/* Right Side Image */}
            <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
              <img src={farmer5} class="object-cover object-center rounded" alt="hero"></img>
            </div>
          </div>

          <section class="">
            <div class="container mx-auto flex px-5 py-12 md:flex-row flex-col items-center">
              <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
                <img src={farmer3} class="object-cover object-center rounded" alt="hero"></img>
              </div>
              <div class="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-end md:text-right items-center text-center">
                <h1 class="text-center md:text-right  mb-4 font-medium text-3xl md:text-4xl lg:text-6xl text-green-600">AGRICULTURAL MODERNIZATION</h1>
                <p class="mb-8 leading-relaxed text-xl">Mayor Cesar T. Quiambao worked with entrepreneurs from the private sector to establish the E-Agro Corporation to carry out agricultural programs with adequate resources.</p>
                <p class="mb-8 leading-relaxed text-xl">Today, the E-Agro Corporation serves as a bridge to farmers and suppliers towards better support, development, and stability</p>


              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

  )
}

export default MoreAboutUs